import { Wrapper } from '@googlemaps/react-wrapper';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './AppRoutes';
import AppContextProvider from './core/context/appContextProvider';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Wrapper apiKey={GOOGLE_MAPS_API_KEY} libraries={['places', 'geometry']}>
      <BrowserRouter>
        <AppContextProvider>
          <AppRoutes />
        </AppContextProvider>
      </BrowserRouter>
    </Wrapper>
  </React.StrictMode>,
);
